import { render, staticRenderFns } from "./ResourcesNew.vue?vue&type=template&id=418b1899"
import script from "./ResourcesNew.vue?vue&type=script&lang=js"
export * from "./ResourcesNew.vue?vue&type=script&lang=js"
import style0 from "./ResourcesNew.vue?vue&type=style&index=0&id=418b1899&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports